// Copyright (c) 2025 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

// DO NOT EDIT.
// Code generated in 2025 by '/services/controlplane/generate/websocket_client/websocket_client.go'
// This file is intended for version control.


export const Model = {
  // Auto is a special model that is used by the LLM router.
  // 
  // When the UI specifies it to "auto", the LLM router will
  // try to determine the best model to used based on the
  // prompt and other factors.
  // 
  ModelAuto: "auto",
  // Anthropic
  // https://docs.anthropic.com/en/docs/about-claude/models
  // 
  AnthropicClaude37Sonnet: "anthropic-claude-3-7-sonnet",
  AnthropicClaude37SonnetThinking: "anthropic-claude-3-7-sonnet-thinking",
  AnthropicClaude35Sonnet: "anthropic-claude-3-5-sonnet",
  AnthropicClaude4Sonnet: "anthropic-claude-4-sonnet",
  AnthropicClaude4SonnetThinking: "anthropic-claude-4-sonnet-thinking",
  // GMI
  // https://inference-engine.gmicloud.ai/
  // 
  MetaLlama4Maverick: "meta-llama-4-maverick",
  DeepSeekR1DistillQwen7b: "deepseek-r1-distill-qwen-7b",
  // Google
  // https://cloud.google.com/vertex-ai/generative-ai/docs/models
  // 
  GoogleGemini20Flash: "google-gemini-2.0-flash",
  GoogleGemini25Pro: "google-gemini-2.5-pro",
  GoogleGemini25Flash: "google-gemini-2.5-flash",
  GoogleGemini25FlashThinking: "google-gemini-2.5-flash-thinking",
  // Groq
  // https://console.groq.com/docs/models
  // 
  MetaLlama3370bVersatile: "meta-llama-3.3-70b-versatile",
  MetaLlama4Scout: "meta-llama-4-scout",
  DeepSeekR1DistillLlama70b: "deepseek-r1-distill-llama-70b",
  // OpenAI
  // https://platform.openai.com/docs/models
  // 
  OpenAIGPT41: "openai-gpt-4.1",
  OpenAIGPT41Mini: "openai-gpt-4.1-mini",
  OpenAIGPT41Nano: "openai-gpt-4.1-nano",
  OpenAIO3: "openai-o3",
  OpenAIO4Mini: "openai-o4-mini",
  // Storytell
  // 
  StorytellCurated: "storytell-curated",
};

// ModelKey provides controlled references to Model values.
export type ModelKey = typeof Model[keyof typeof Model];
